import { Button } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useDefineUserRole } from '../../../hooks';
import { useDownloadCategoriesCallback } from '../../../pages/home/products/hooks/useDownloadAllCategoriesCallback';

const ButtonGetCategiry: React.FC = () => {
  const intl = useIntl();
  const { me } = useSelector(({ profile }: any) => profile);

  const isRoleAdmin = useDefineUserRole(me, 'ROLE_ADMIN');
  const isRoleVendor = useDefineUserRole(me, 'ROLE_VENDOR');
  const isRoleManager = useDefineUserRole(me, 'ROLE_MANAGER');

  const downloadIdCategories = useDownloadCategoriesCallback();
  const getCategoryId = useCallback(() => {
    downloadIdCategories();
  }, []);

  return (
    <>
      {(isRoleAdmin || isRoleManager || isRoleVendor) && (
        <Button  color='default' variant='outlined' 
          style={{ marginLeft: '10px' }} onClick={()=> getCategoryId()}
        >
          ID КАТЕГОРИЙ
        </Button>
      )}
    </>
  );
};

export default ButtonGetCategiry;
